import React from 'react';

const RequestStep = () => {

  return <div className='text-sm/7 bg-new-white rounded-lg p-4'>
    <div className='text-lg font-bold text-center mt-2'>
      동화 제작 신청 방법
    </div>
    <div className='mt-4'>
      <div className='font-bold'>
        1. 간편로그인으로 3초만에 회원가입
      </div>
      <div>
        <img src="../image/guide/login.png" className='w-1/3' />
      </div>
    </div>
    <div className='mt-4'>
      <div className='font-bold'>
        2. 주인공 추가
      </div>
      <div>
        <img src="../image/guide/add_btn.png" className='w-1/3' />
      </div>
    </div>
    <div className='mt-4'>
      <div className='font-bold'>
        3. 동화에 사용될 주인공, 가족, 친구 정보 입력
      </div>
      <div>
        <img src="../image/guide/hero.png" className='w-2/3' />
      </div>
      <div className='mt-4'>
        <img src="../image/guide/family.png" className='w-2/3' />
      </div>
    </div>
    <div className='mt-4'>
      <div className='font-bold'>
        4. 정보 입력이 완료되면 "이야기 생성하기" 체크
      </div>
      <div>
        <img src="../image/guide/request.png" className='w-2/3' />
      </div>
    </div>
  </div>
}

export default RequestStep
